import { kebabCase, getOr } from 'lodash/fp';
import { DOMAIN_PREFIX } from 'helpers/fieldOptions/domainPrefix';
import { LOCALE } from 'helpers/i18n';
import { RETAIL } from 'constants/sellerType';
import { FAQ_URL_BY_LOCALES } from './getFaqUrl';
import { FAVORITE_URL_KEY_BY_LOCALE } from './getFavoritesUrl';

export const getInspectionV2FunnelUrl = () => `/inspection`;
export const getInspectionV2Url = (carLeadHash) => `/inspection/${carLeadHash}`;
export const getThankYouUrl = () => `/inspection/thank-you`;
export const getThankYouPhoneUrl = (carLeadHash) =>
  `/inspection/${carLeadHash}/thank-you`;
export const getThankYouPhonePreferenceUrl = (carLeadHash) =>
  `/inspection/${carLeadHash}/thank-you-preference`;
export const getEmailThankYouUrl = (carLeadHash) =>
  `/inspection/${carLeadHash}/thank-you-email`;

export const getPriceCalculatingUrl = (carLeadHash) =>
  `/inspection/${carLeadHash}/calculating-price`;

export const getPrivateListingEditUrl = (carLeadHash) =>
  `/${DOMAIN_PREFIX}/privat/edit/id/${carLeadHash}`;

export const getFaqUrl = () => getOr('', [LOCALE], FAQ_URL_BY_LOCALES);
export const getManualSeoSearchUrl = (link) => `/${DOMAIN_PREFIX}/${link}/`;
export const getSearchUrl = () => `/${DOMAIN_PREFIX}/`;
export const getSeoSearchUrl = (link) => `/${DOMAIN_PREFIX}/${link}/`;
export const getFavoritesUrl = () =>
  `/${DOMAIN_PREFIX}${FAVORITE_URL_KEY_BY_LOCALE}`;
export const getDislikesUrl = () =>
  `/${DOMAIN_PREFIX}${FAVORITE_URL_KEY_BY_LOCALE}?dislike=true`;

const MID_CODES = {
  'de': 'DE_CMX_16-103_11_18_8-0-3-0_0_0',
  'fr': 'FR_CMX_16-113_11_18_8-0-3-0_0_0',
  'it': 'IT_CMX_16-104_11_18_8-0-3-0_0_0',
  'es': 'ES_CMX_16-105_11_18_8-0-3-0_0_0',
  'de-at': 'AT_CMX_16-106_11_18_8-0-3-0_0_0',
  'nl-be': 'B1_CMX_16-116_11_18_8-0-3-0_0_0',
  'fr-be': 'B2_CMX_16-117_11_18_8-0-3-0_0_0',
  'nl': 'NL_CMX_16-115_11_18_8-0-3-0_0_0',
  'sv-se': 'SE_CMX_16-114_11_18_8-0-3-0_0_0',
};

export const getAdUrl = (
  {
    id,
    manufacturer,
    model,
    sellerType,
    subType,
    subTypeExtra,
    title,
    pathTitle,
    ignorePathTitle,
  },
  domain = `/${DOMAIN_PREFIX}`,
) => {
  let text = kebabCase(
    title || `${manufacturer}-${model}-${subType}-${subTypeExtra}`,
  );
  const mid = MID_CODES[LOCALE] || '';

  if (sellerType === RETAIL) {
    text = kebabCase(`${manufacturer}-${model}`);
  } else {
    text += `/${sellerType}`;
  }

  if (pathTitle && !ignorePathTitle) {
    text = `${pathTitle}/${sellerType}`;
  }

  return `${`${domain}/${text}/id/${id}/`.toLowerCase()}?MID=${mid}`;
};

export const getSelfEvaFunnelUrl = () => `/inspection/`;
export const getSelfEvaFunnelUrlV2 = () => `/inspection/v2`;

export const hasExperiment = (pathname) =>
  pathname.includes(getSelfEvaFunnelUrl());
